export default "__VITE_ASSET__f4964afb__"